import React, { FC, useState, useMemo } from 'react'
import MobileHeader from './MobileHeader/MobileHeader'
import DesktopHeader from './DesktopHeader/DesktopHeader'
import { HeaderProvider, MobileHeaderConfig } from './HeaderContext'
import { NavigationLinks } from './NavigationLinks'
import CartUrgencyBar from 'components/CartUrgencyBar'
import styles from './Header.module.scss'
import { transformNavigationLinks } from './helpers'
import { useSelector } from 'react-redux'
import { getUserPreferencesSelectedCurrency } from 'selectors/user/cookie'
import { getNavArrivalsVariant } from 'selectors/shared/navArrivalsVariant'
import { NewArrivalsNavVariant } from 'lib/abTest/data'
import useAbTestTracking from 'hooks/useAbTestTracking'

const Header: FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null)
  const [mobileHeaderConfig, setMobileHeaderConfig] = useState<MobileHeaderConfig>({
    mobileTopHeader: 'mainTopHeader',
    mobileMenuContent: 'null',
    isMobileMenuOpen: false,
  })

  const localeCurrency = useSelector(getUserPreferencesSelectedCurrency)
  const navArrivalsVariant = useSelector(getNavArrivalsVariant)
  const isNewArrivalsEnabled = navArrivalsVariant === '01'

  useAbTestTracking(NewArrivalsNavVariant, navArrivalsVariant)

  const transformedNavigationLinks = useMemo(() => {
    return transformNavigationLinks({
      navigationLinks: NavigationLinks,
      localeCurrency,
      isNewArrivalsEnabled,
    })
  }, [isNewArrivalsEnabled, localeCurrency])

  return (
    <HeaderProvider
      value={{
        selectedCategory,
        setSelectedCategory,
        mobileHeaderConfig,
        setMobileHeaderConfig,
        navigationLinks: transformedNavigationLinks,
        isNewArrivalsEnabled,
      }}
    >
      <MobileHeader />
      <DesktopHeader />
      <div className={styles.cartUrgencyBox}>
        <CartUrgencyBar />
      </div>
    </HeaderProvider>
  )
}

export default Header
